import React, { useState, useEffect } from "react";
import {
  StyleSheet,
  View,
  Text,
  TouchableOpacity,
  SafeAreaView,
  Platform,
} from "react-native";

import AppConfig from "../../../config/AppConfig";

import Icons from "../common/icons/index";
import ImageComponent from "../common/ImageComponent";
import { isAppleDevice, isWeb, navigate, getStorageItem, setStorageItem } from "../../../helpers/utils";
import headerStyles from "../common/header/headerStyles";
import AppTheme from "../AppTheme";
import PageMoreCards from "./PageMoreCards";

export default function PageMoreHeader({
  controller,
  toggleCopyDialog = () => {},
}) {
  const [userAvatar, setUserAvatar] = useState();
  const [currentUser, setCurrentUser] = useState();
  const [guide, setGuide] = useState();

  const goBack = () => {
    if (AppConfig.USE_DRAWER) {
      controller.navigation.closeDrawer();
      
      getStorageItem("onboarding_started").then((isFromOnboarding) => {
        if (!!isFromOnboarding) {
          setStorageItem("onboarding_started", null);
          controller.navigation.goBack();
        }

      });

    } else {
      controller.goBack();
    }
  };

  useEffect(() => {
    setUserAvatar(controller.state?.picture);
    //setGuideAvatar(controller.state?.settings?.guide_avatar);
    const email =
      controller.state?.settings?.email_edited ||
      controller.state?.impersonate ||
      controller.state?.currentUser;
    const user = controller.state?.settings?.nickname || email;

    setCurrentUser(user);
    setGuide(controller.state?.settings?.primary_guide);
  }, [controller.state?.settings]);

  const goToProfile = () => {
    if (AppConfig.USE_DRAWER) {
      controller.navigation.closeDrawer();
    }
    navigate(controller, "rn:profile", {});
  };

  const goHome = () => {
    controller.navigate("feed");
  };

  return (
    <SafeAreaView style={[styles.container]}>
      <View style={styles.header}>
        <View style={styles.row1}>
          <View style={headerStyles.leftContainer}>
            <Icons.Back onPress={goBack} />
          </View>

          <TouchableOpacity style={styles.logoContainer} onPress={goHome}>
            <ImageComponent
              image={require("../../../assets/WhiteHorizontal.png")}
              styles={{ width: 135, height: 40 }}
            />
          </TouchableOpacity>
        </View>

        <View style={styles.row2}>
          <View>
            <Text style={styles.emailText}>{currentUser}</Text>
            {guide ? (
              <Text style={styles.guideText}>Coach: {guide}</Text>
            ) : null}
          </View>

          {userAvatar ? (
            <TouchableOpacity
              onPress={goToProfile}
              onLongPress={() => toggleCopyDialog(true)}
            >
              <ImageComponent image={userAvatar} styles={styles.avatar} />
            </TouchableOpacity>
          ) : null}
        </View>
      </View>

      {isWeb ? <PageMoreCards controller={controller} /> : null}
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: AppTheme.headerBg,
    paddingBottom: 16,
  },
  header: {
    position: "relative",
    paddingTop: isAppleDevice ? 0 : 20,
  },
  row1: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
  },
  logoContainer: {
    width: "100%",
    paddingLeft: 42,
  },
  row2: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "row",
    marginTop: 6,
    paddingHorizontal: 42,
  },
  emailText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    color: AppTheme.title,
  },
  guideText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: AppTheme.title,
    marginTop: 8,
  },
  imageIcon: {
    width: 30,
    height: 30,
    marginBottom: 5,
  },
  avatar: {
    width: 48,
    height: 48,
    borderRadius: 48,
  },
});
